"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationForwarder = void 0;
var axios_1 = __importDefault(require("axios"));
var join_1 = require("./join");
var UrlParser_1 = require("./UrlParser");
function getDomain(url) {
    var inst = new UrlParser_1.UrlParser(url);
    var origin = inst.origin;
    if (!origin) {
        throw new Error('Invalid url');
    }
    return origin;
}
var AuthorizationForwarder = /** @class */ (function () {
    function AuthorizationForwarder(agent, forwardToUrl, resourceUri, options) {
        this.prepareAxiosConfig = null;
        this.prepareAxiosResponse = null;
        this.prepareResponse = null;
        this.signedAxiosConfig = null;
        this.signedAxiosResponse = null;
        this.signedResponse = null;
        this.DefaultForwardOptions = {
            prepareMethod: 'POST',
            signedMethod: 'PUT',
            prepareAuth: function (inst) {
                return inst.agent.generateAuthenticationJCT({ aud: inst.destAudience + '/api' }, 30);
            },
            signedAuth: function (inst) {
                return inst.agent.generateAuthenticationJCT({ aud: inst.destAudience + '/api' }, 30);
            },
            signCert: function (inst) {
                if (!inst.prepareResponse) {
                    return Promise.reject(new Error('.prepareResponse is expected to be defined'));
                }
                return inst.agent.signResourceCertificate(inst.resourceUri, inst.prepareResponse.jcr, inst.prepareResponse.jct, inst.getForwardOption('permissions'), 
                // 5 minutes certificate
                300);
            },
        };
        this.agent = agent;
        this.options = options;
        this.prepareUrl = typeof forwardToUrl === 'string' ? (0, join_1.join)('/', forwardToUrl, 'prepare') : forwardToUrl.prepare;
        this.signedUrl = typeof forwardToUrl === 'string' ? (0, join_1.join)('/', forwardToUrl, 'signed') : forwardToUrl.signed;
        this.destAudience = getDomain(this.prepareUrl);
        if (getDomain(this.signedUrl) !== this.destAudience) {
            throw new Error('.forwardUrl.prepare and .forwardUrl.signed are expected to be on the same domain');
        }
        this.resourceUri = resourceUri;
    }
    /**
     * Used to retrieve the value of an option, firstly from the passed options,
     * or from the default values
     * @param key option to retrieve
     */
    AuthorizationForwarder.prototype.getForwardOption = function (key) {
        if (this.options && key in this.options) {
            return this.options[key];
        }
        else if (key in this.DefaultForwardOptions) {
            return this.DefaultForwardOptions[key];
        }
        return;
    };
    /**
     * Used to promisify a handle
     */
    AuthorizationForwarder.prototype.promisify = function (handle) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, handle(this)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Run the whole thing
     */
    AuthorizationForwarder.prototype.solve = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prepare()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.sign()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * sends the prepare request, retrieving the certificate request and
     * authentication token
     */
    AuthorizationForwarder.prototype.prepare = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, promises, generatePrepareAuth, generatePrepareEtc, prepareResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            url: this.prepareUrl,
                            method: this.getForwardOption('prepareMethod'),
                        };
                        promises = [];
                        generatePrepareAuth = this.getForwardOption('prepareAuth');
                        if (generatePrepareAuth) {
                            promises.push(this.promisify(generatePrepareAuth).then(function (token) {
                                options.headers = {
                                    authorization: "Bearer ".concat(token),
                                };
                            }));
                        }
                        generatePrepareEtc = this.getForwardOption('prepareEtc');
                        if (generatePrepareEtc) {
                            promises.push(this.promisify(generatePrepareEtc).then(function (etc) {
                                options.data = {
                                    etc: etc,
                                };
                            }));
                        }
                        // wait for everything to be ready
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        // wait for everything to be ready
                        _a.sent();
                        return [4 /*yield*/, axios_1.default.request((this.prepareAxiosConfig = options))];
                    case 2:
                        prepareResponse = _a.sent();
                        this.prepareAxiosResponse = prepareResponse;
                        if (!('prepare' in prepareResponse.data)) {
                            throw new Error('Invalid prepare response, missing .prepare object');
                        }
                        if (!('jcr' in prepareResponse.data.prepare)) {
                            throw new Error('Invalid prepare response, missing .prepare.jcr string');
                        }
                        if (!('jct' in prepareResponse.data.prepare)) {
                            throw new Error('Invalid prepare response, missing .prepare.jct string');
                        }
                        this.prepareResponse = {
                            jcr: prepareResponse.data.prepare.jcr,
                            jct: prepareResponse.data.prepare.jct,
                            etc: prepareResponse.data.etc,
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * signs the certificate and sends the signed request.
     */
    AuthorizationForwarder.prototype.sign = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, promises, data, generateSignedAuth, generateSignedEtc, generateSignCert, signedResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {
                            url: this.signedUrl,
                            method: this.getForwardOption('signedMethod'),
                        };
                        promises = [];
                        data = {};
                        generateSignedAuth = this.getForwardOption('signedAuth');
                        if (generateSignedAuth) {
                            promises.push(this.promisify(generateSignedAuth).then(function (token) {
                                options.headers = {
                                    authorization: "Bearer ".concat(token),
                                };
                            }));
                        }
                        generateSignedEtc = this.getForwardOption('signedEtc');
                        if (generateSignedEtc) {
                            promises.push(this.promisify(generateSignedEtc).then(function (etc) {
                                data.etc = etc;
                            }));
                        }
                        generateSignCert = this.getForwardOption('signCert');
                        if (generateSignCert) {
                            promises.push(this.promisify(generateSignCert).then(function (jsc) {
                                data.signed = { jsc: jsc };
                            }));
                        }
                        else {
                            throw new Error('No certificate signature handle provided');
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        // assign data to our request
                        options.data = data;
                        return [4 /*yield*/, axios_1.default.request((this.signedAxiosConfig = options))];
                    case 2:
                        signedResponse = _a.sent();
                        this.signedAxiosResponse = signedResponse;
                        this.signedResponse = {
                            certificate_id: signedResponse.data.signed.certificate_id,
                        };
                        return [2 /*return*/];
                }
            });
        });
    };
    return AuthorizationForwarder;
}());
exports.AuthorizationForwarder = AuthorizationForwarder;
